import React, { useState } from "react";
import styles from "./RemoveCompletionButton.module.css";
import Icon from "@/ui/icon/Icon";
import { useUnwatchVideo } from "@/features/courses/hooks/useUnwatchVideo";

function RemoveCompletionButton({ video, resetToStart }) {
	const [isDisappearing, setIsDisappearing] = useState(false);
	const { unwatch } = useUnwatchVideo({ unit: video });

	const handleClick = async () => {
		setIsDisappearing(true);
		await resetToStart();
		setTimeout(async () => {
			await unwatch();
		}, 500);
	};

	return (
		<button
			className={`${styles.button} ${
				isDisappearing ? styles.buttonDisappearing : ""
			}`}
			onClick={handleClick}
			disabled={isDisappearing}
		>
			<span className={styles.defaultIcon}>
				<Icon icon="fa-eye" />
			</span>
			<span className={styles.hoverIcon}>
				<Icon icon="fa-eye-slash" />
			</span>
		</button>
	);
}

export default RemoveCompletionButton;
